import { useEffect } from 'react';
import { useSessao } from '../auth/SessaoContext';
import { registrarVisita } from '../util/visita';
import { medirCliques } from '../util/clique';
import { Cabecalho } from './publico/Cabecalho';
import { Chamada } from './publico/Chamada';
import { ComoFunciona } from './publico/ComoFunciona';
import { DuasFormas } from './publico/DuasFormas';
import { Escritorios } from './publico/Escritorios';
import { Captura } from './publico/Captura';
import { Precos } from './publico/Precos';
import { ParaDesenvolvedores } from './publico/ParaDesenvolvedores';
import { Seguranca } from './publico/Seguranca';
import { Duvidas } from './publico/Duvidas';
import { ChamadaFinal } from './publico/ChamadaFinal';
import { Rodape } from './publico/Rodape';
import { usePrecos } from './publico/usePrecos';
import base from './publico/publico.module.css';

// Outras páginas importam estes daqui; as peças moram em `publico/`.
export { Rodape } from './publico/Rodape';
export { Passo } from './publico/Passo';

/**
 * Página pública.
 *
 * Regra que vale para tudo aqui: só entra o que o produto FAZ hoje. Nada de
 * teste grátis (não existe), de SLA (a vazão depende da fonte), de depoimento,
 * logo de cliente ou contagem de usuários que não dê para provar, nem de preço
 * escrito à mão — a faixa vem de `GET /creditos/precos`, a mesma tabela que
 * reserva o saldo. Anunciar um número que o sistema não cobra é o tipo de
 * promessa que se descobre quebrada só na fatura.
 *
 * Seções: chamada (+ faixa de confiança) · como funciona · duas formas de usar
 * · para escritórios · captura automática · preços · API · segurança · dúvidas ·
 * chamada final · rodapé.
 */
export function Landing() {
  const { usuario } = useSessao();
  const { precos, falhou } = usePrecos();
  const logado = !!usuario;

  // Só a página pública conta: o painel é uso de quem já é cliente, e misturar
  // os dois faria o número medir engajamento em vez de propagação.
  //
  // Repete ao mudar o consentimento: quem aceita no banner é contado na hora,
  // em vez de só na próxima visita.
  useEffect(() => {
    registrarVisita();
    const aoDecidir = () => registrarVisita();
    window.addEventListener('bx:consentimento', aoDecidir);
    return () => window.removeEventListener('bx:consentimento', aoDecidir);
  }, []);

  useEffect(() => medirCliques(), []);

  return (
    <div className={base.pagina}>
      <Cabecalho naHome />
      <main>
        <Chamada
          logado={logado}
          bonusCentavos={precos?.bonusCadastroCentavos ?? 0}
        />
        <ComoFunciona />
        <DuasFormas />
        <Escritorios />
        <Captura logado={logado} />
        <Precos precos={precos} falhou={falhou} logado={logado} />
        <ParaDesenvolvedores logado={logado} />
        <Seguranca />
        <Duvidas />
        <ChamadaFinal logado={logado} />
      </main>
      <Rodape />
    </div>
  );
}
